var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaveMountainPanorama(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2000 445",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "linka"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1831.185 398.628l-1.954-64.495-22.476-20.522-20.521-4.886-42.997.977-35.18-1.954-11.726-4.886-9.772-7.817-39.088-2.932-29.56-13.925-7.33 10.26-18.322 3.665-21.987 1.466-14.658 5.863-30.049 8.062-19.788-1.466h-10.261l-5.863 3.664-12.46-1.465-10.338-.544-.004-.433-72.883-22.232-32.247 2.199-31.515-15.391-35.179-3.664-17.59-10.994h-11.727l-2.931-.733-5.13-5.863-5.8-2.87-5.759-19.579-22.659-5.665-17.938-4.721-11.331-4.72-15.105 5.665-12.274 6.609-26.436 7.552-9.441 16.051-31.849 7.541-2.14 6.621-28.324-.945-10.997 8.514-10.29 1.201-24.186 5.13-30.782-1.466-26.385-10.993-25.651-9.528h-33.714l-14.658-11.726-18.322-7.329-13.926-5.131-10.993-7.328-21.987-3.665-27.85-12.948-15.066 2.199-16.856-7.33h-19.789l-19.381 7.818-19.788 1.466-15.391-4.886-15.391 8.551-24.186 5.13h-2.199l-12.133-9.284-13.193 1.955-16.612-11.727-26.384-10.749-14.17-5.863-28.176-5.374-13.192-8.062-18.404 6.27-31.84-8.225-22.313 4.153-18.323 8.795-29.316 5.863-5.863 5.13-27.851 14.659-5.863 13.925-19.788 7.329-13.192 8.062-12.46 8.794-14.658 9.528-21.987 18.323.326 147.313h1182.415l-.329-38.167z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1587.24 318.751l.346 1.707h-1.435v-1.707z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1585.063 318.751l-.346 1.707h1.434v-1.707z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1586.151 309.981l-6.854 9.365 4.482-1.145 2.372 1.016z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1586.151 306.942l-5.776 7.892 3.777-.966 1.999.857z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1586.151 304.873l-4.307 5.886 2.816-.72 1.491.639z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1586.151 309.983l6.855 9.366-4.482-1.146-2.373 1.016z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1586.151 306.944l5.777 7.892-3.777-.965-2 .856z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1586.151 304.875l4.308 5.886-2.816-.72-1.492.639z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1090.332 281.617l.346 1.707h-1.434v-1.707z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1088.155 281.617l-.346 1.707h1.435v-1.707z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1089.244 272.847l-6.855 9.366 4.482-1.146 2.373 1.016z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1089.244 269.808l-5.777 7.892 3.777-.965 2 .856z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1089.244 267.739l-4.308 5.887 2.816-.72 1.492.638z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1089.244 272.849l6.854 9.366-4.482-1.146-2.372 1.016z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1089.244 269.81l5.776 7.892-3.777-.965-1.999.856z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1089.244 267.741l4.308 5.887-2.817-.72-1.491.638z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1003.035 293.669l.346 1.708h-1.434v-1.708z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1000.858 293.669l-.345 1.708h1.434v-1.708z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1001.947 284.899l-6.855 9.366 4.482-1.146 2.373 1.016z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1001.947 281.86l-5.776 7.892 3.776-.965 2 .856z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1001.947 279.792l-4.308 5.886 2.817-.72 1.491.638z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1001.947 284.901l6.854 9.366-4.481-1.146-2.373 1.016z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1001.947 281.862l5.776 7.892-3.777-.965-1.999.856z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1001.947 279.794l4.308 5.886-2.817-.72-1.491.638z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1283.818 295.323l.346 1.707h-1.434v-1.707z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1281.641 295.323l-.345 1.707h1.434v-1.707z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1282.73 286.553l-6.855 9.366 4.482-1.146 2.373 1.016z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1282.73 283.514l-5.776 7.892 3.776-.966 2 .857z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1282.73 281.445l-4.308 5.886 2.817-.72 1.491.639z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1282.73 286.555l6.854 9.366-4.481-1.146-2.373 1.016z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1282.73 283.516l5.776 7.892-3.777-.965-1.999.856z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1282.73 281.447l4.308 5.886-2.817-.72-1.491.639z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1046.939 294.291l.346 1.708h-1.434v-1.708z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1044.762 294.291l-.345 1.708h1.434v-1.708z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1045.851 285.522l-6.855 9.365 4.482-1.145 2.373 1.015z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1045.851 282.482l-5.776 7.893 3.776-.966 2 .856z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1045.851 280.414l-4.308 5.886 2.816-.72 1.492.638z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1045.851 285.524l6.854 9.365-4.481-1.145-2.373 1.016z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1045.851 282.484l5.776 7.893-3.777-.966-1.999.856z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1045.851 280.416l4.308 5.886-2.817-.72-1.491.638z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1246.929 297.481l.346 1.707h-1.435v-1.707z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1244.752 297.481l-.346 1.707h1.434v-1.707z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1245.84 288.711l-6.854 9.365 4.482-1.145 2.372 1.016z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1245.84 285.672l-5.776 7.892 3.777-.966 1.999.856z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1245.84 283.603l-4.308 5.886 2.817-.72 1.491.639z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1245.84 288.713l6.855 9.366-4.482-1.146-2.373 1.016z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1245.84 285.674l5.777 7.892-3.777-.966-2 .857z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1245.84 283.605l4.308 5.886-2.816-.72-1.492.639z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1231.843 298.164l.298 1.472h-1.237v-1.472z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1229.966 298.164l-.298 1.472h1.236v-1.472z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1230.904 290.601l-5.911 8.076 3.865-.988 2.046.876z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1230.904 287.98l-4.981 6.806 3.257-.833 1.724.739z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1230.904 286.196l-3.715 5.076 2.429-.621 1.286.551z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1230.904 290.603l5.911 8.076-3.864-.988-2.047.876z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1230.904 287.982l4.981 6.806-3.256-.833-1.725.738z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1230.904 286.198l3.715 5.076-2.429-.621-1.286.551z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1667.748 325.827c-60.098-5.375-150.001-18.567-150.001-18.567l-7.817-9.772-8.795-2.443-7.329-8.306-7.896-4.136-.248-1.239-7.818-10.749 2.932-15.636-25.407-11.726-4.886-7.818-8.794-2.932-20.521 4.886-4.886 6.84-10.75 6.84-2.932 11.727-6.84 3.909-5.863 6.841s-24.918 12.215-97.231 19.055c-72.313 6.84-76.955 4.642-76.955 4.642l-12.459-17.834-14.658-2.932-19.544 14.169-12.867 4.561-9.935 15.635h-5.7l-2.769-10.668-13.681-17.834-6.84-5.863h-13.681l-3.909 3.909h-18.566l-10.75 11.726s-36.157 1.955-72.313-.977c-36.157-2.932-135.994-37.134-135.994-37.134l-14.658-10.749-29.968-.651-21.498 8.143-17.915-12.052-12.052-5.212-23.453-2.932-14.658 8.143-12.704 5.212-19.87 2.28-18.567 14.658-30.293 10.749-21.498.326-38.111 28.013 17.264 109.691h879.483l360.588-32.492 15.635-42.02c-.001.002-131.924-3.907-192.022-9.281z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1137.841 363.458s11.465-3.181 25.749 3.122c14.284 6.303 44.583 18.611 58.424 16.562 13.841-2.049 24.123-5.877 41.534-10.145 17.41-4.268 39.889-4.865 53.904-2.007s81.321 15.178 81.321 15.178l160.587-12.704s-147.558-21.824-258.496-25c-44.497-.898-60.958 19.098-87.257 16.92-26.299-2.178-41.057-16.345-64.13-15.378s-104.451 15.315-104.451 15.315l28.99 4.235 63.825-6.098z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1389.841 379.502l-3.22-7.785-5.565 7.736-4.158-8.037-4.988 7.983-3.698-8.261-5 8.361-3.066-9.025-4.657 9.228-2.187-9.577-5.802 8.55-1.491-9.1-7.439 8.286-2.603-8.723-7.207 7.173-3.692-8.673-5.626 7.149-1.752-7.873-6.489 6.539-1.706-7.296-7.069 6.48-1.055-7.749-5.234 6.333-2.194-7.528-5.007 6.284-1.059-7.278-6.151 6.148-.193-6.585-5.094 5.674-1.216-7.438-5.537 6.167-1.213-7.311-5.489 5.772-1.84-7.173-4.787 5.691-.368-6.842-4.468 4.292-.464-5.569-4.756 4.245.01-5.868-5.517 4.955-.5-6.233-4.619 3.739.046-5.32-4.849 3.343-.093-4.814-5.01 2.852-.408-4.667-3.614 3.157-.232-4.298-3.6 2.804-.244-4.531-3.929 2.277.038-3.771-3.452 2.285-.77-3.706-2.89 1.935-.91-3.733-2.833 2.616-.377-3.787-3.512 2.083-.203-3.765-3.681 2.052.292-3.562-3.356 2.034.147-3.558-3.821 1.703.405-3.132-3.696 1.597.474-2.952-3.055 1.62-.184-3.412-3.431 1.408-.163-3.047-3.785 1.329-.505-3.419-3.131 1.434.015-2.861-2.667.884.1-2.719-3.657 1.084-.035-2.294-3.396-.059-.204-2.442-2.598 1.438-.333-3.204-2.669 1.648-.075-3.086-4.584.589.746-2.528-3.063.551.172-2.571-3.228 1.187.844-4.356.982.19-.507 2.616 3.01-1.107-.19 2.831 3.399-.612-.772 2.612 4.164-.534.059 2.451 2.541-1.568.342 3.285 2.628-1.455.257 3.081 3.46.061.03 1.942 3.728-1.106-.099 2.673 2.622-.868-.014 2.685 2.918-1.337.522 3.539 3.899-1.369.16 2.972 3.431-1.408.175 3.255 3.447-1.827-.504 3.135 3.637-1.571-.402 3.109 3.666-1.635-.136 3.306 3.436-2.082-.298 3.647 3.444-1.92.2 3.717 3.442-2.043.333 3.351 2.606-2.406.974 3.994 2.934-1.966.772 3.714 3.792-2.51-.039 3.899 3.822-2.216.228 4.251 3.601-2.804.224 4.159 3.551-3.1.443 5.074 5.117-2.913.09 4.637 4.902-3.38-.045 5.124 4.446-3.598.49 6.108 5.686-5.107-.01 5.878 4.581-4.088.457 5.472 4.527-4.347.349 6.495 4.411-5.243 1.874 7.307 5.627-5.919 1.201 7.239 5.541-6.173 1.216 7.438 5.37-5.98.199 6.769 5.922-5.92 1.013 6.965 4.77-5.986 2.206 7.567 5.486-6.638 1.104 8.118 6.92-6.343 1.684 7.201 6.506-6.556 1.691 7.601 5.366-6.818 3.776 8.866 7.345-7.31 2.571 8.615 7.641-8.51 1.423 8.683 5.683-8.377 2.081 9.114 4.481-8.879 3.136 9.235 4.876-8.155 3.717 8.303 4.923-7.882 4.216 8.149 5.664-7.872 3.906 9.446z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1140.567 310.863s50.092 34.987 103.94 53.62c45.43 13.38 65.829 14.968 65.829 14.968s49.227 1.099 79.734-.428c-14.253-.243-85.6-.477-159.924-26.816-68.034-27.656-83.858-41.385-83.858-41.385l-5.721.041z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1392.948 372.4c-.929-.007-91.47-1.441-151.711-19.993-60.247-18.554-94.28-42.579-94.617-42.819l.581-.814c.336.239 30.184 22.295 90.264 40.796 60.102 18.509 156.575 19.451 157.503 19.458l-2.02 3.372z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1066.743 306.052l.541 2.673h-2.246v-2.673z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063.334 306.052l-.541 2.673h2.245v-2.673z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1065.038 292.32l-10.732 14.665 7.017-1.794 3.715 1.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1065.038 287.561l-9.044 12.358 5.914-1.512 3.13 1.341z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1065.038 284.323l-6.745 9.216 4.41-1.127 2.335.999z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1065.038 292.324l10.733 14.664-7.017-1.794-3.716 1.591z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1065.038 287.565l9.045 12.357-5.914-1.511-3.131 1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1065.038 284.326l6.746 9.216-4.411-1.127-2.335 1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1018.924 300.487l.542 2.674h-2.246v-2.674z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1015.516 300.487l-.542 2.674h2.246v-2.674z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1017.22 286.755l-10.733 14.665 7.018-1.794 3.715 1.591z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1017.22 281.997l-9.044 12.357 5.913-1.511 3.131 1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1017.22 278.758l-6.745 9.216 4.41-1.127 2.335.999z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1017.22 286.759l10.733 14.664-7.018-1.794-3.715 1.591z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1017.22 282l9.044 12.357-5.913-1.511-3.131 1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1017.22 278.761l6.745 9.216-4.41-1.127-2.335 1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1307.104 300.3l.541 2.673h-2.246V300.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1303.695 300.3l-.541 2.673h2.245V300.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1305.399 286.568l-10.732 14.664 7.017-1.793 3.715 1.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1305.399 281.809l-9.044 12.358 5.913-1.512 3.131 1.341z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1305.399 278.57l-6.745 9.217 4.41-1.128 2.335 1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1305.399 286.571l10.733 14.665-7.018-1.794-3.715 1.591z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1305.399 281.813l9.044 12.357-5.913-1.512-3.131 1.341z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1305.399 278.574l6.745 9.216-4.41-1.127-2.335.999z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_6_00000141446575315588339720000008626430833555998090_",
    className: "st11",
    d: "M-1.641 446.837l.163-137.46c17.536-7 37.07-13.911 55.147-19.344a661.273 661.273 0 0163.63-15.7 681.07 681.07 0 0134.031-5.719 693.679 693.679 0 0135.514-4.1c18.627-1.664 40.274-2.51 64.339-2.51 22.674 0 48.15.752 75.721 2.234 25.934 1.4 54.473 3.478 84.823 6.192 28.3 2.531 59.047 5.688 91.374 9.382 29.808 3.407 61.9 7.379 95.377 11.8 57.267 7.57 120.254 16.666 192.558 27.808 62.8 9.677 123.841 19.543 177.7 28.247l.2.032.075.012 7 1.131c55 8.908 111.217 16.042 167.095 21.2 33.243 3.071 66.6 5.45 99.133 7.072 35.881 1.788 71.583 2.695 106.115 2.695 20.432 0 40.885-.318 60.79-.945a1778.78 1778.78 0 0061.711-3.009c21.025-1.4 41.951-3.191 62.2-5.329a1462.225 1462.225 0 0062.253-7.906c44.572-6.648 90.615-12.944 136.851-18.712 43.066-5.374 126.24-13.241 159.368-15.032 33.968-1.836 98.942-.607 98.942-.607h10.179v117.57l-2002.289.998z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M859.962 356.606l1.238 6.115h-5.136v-6.115z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.166 356.606l-1.238 6.115h5.136v-6.115z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M856.064 325.2l-24.547 33.54 16.049-4.103 8.498 3.638z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M856.064 314.316l-20.686 28.263 13.525-3.457 7.161 3.066z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M856.064 306.909l-15.428 21.079 10.087-2.579 5.341 2.287z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M856.064 325.208l24.547 33.539-16.05-4.102-8.497 3.638z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M856.064 314.324l20.685 28.263-13.525-3.457-7.16 3.065z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M856.064 306.916l15.427 21.079-10.087-2.578-5.34 2.286z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M750.782 369.025l1.548 7.642h-6.42v-7.642z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.038 369.025l-1.547 7.642h6.419v-7.642z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M745.91 329.771l-30.681 41.92 20.061-5.128 10.62 4.547z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M745.91 316.167l-25.854 35.326 16.905-4.321 8.949 3.831z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M745.91 306.909l-19.282 26.346 12.607-3.223 6.675 2.858z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M745.91 329.78l30.681 41.921-20.06-5.128-10.621 4.547z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M745.91 316.177l25.854 35.325-16.904-4.321-8.95 3.832z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M745.91 306.918l19.283 26.346-12.608-3.223-6.675 2.858z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1440.678 388.932l1.217 6.011h-5.048v-6.011z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1433.016 388.932l-1.217 6.011h5.048v-6.011z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1436.847 358.063l-24.128 32.967 15.776-4.033 8.352 3.576z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1436.847 347.365l-20.332 27.78 13.294-3.398 7.038 3.013z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1436.847 340.084l-15.164 20.719 9.915-2.534 5.249 2.247z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1436.847 358.071l24.127 32.966-15.775-4.033-8.352 3.576z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1436.847 347.373l20.332 27.78-13.294-3.398-7.038 3.013z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1436.847 340.092l15.164 20.718-9.915-2.534-5.249 2.247z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1390.793 381.656l.768 3.793h-3.186v-3.793z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1385.957 381.656l-.768 3.793h3.186v-3.793z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1388.375 362.174l-15.227 20.806 9.956-2.545 5.271 2.256z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1388.375 355.423l-12.831 17.532 8.39-2.145 4.441 1.902z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1388.375 350.828l-9.57 13.076 6.258-1.6 3.312 1.418z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1388.375 362.179l15.227 20.805-9.956-2.545-5.271 2.257z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1388.375 355.428l12.832 17.532-8.39-2.145-4.442 1.902z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1388.375 350.832l9.57 13.076-6.257-1.599-3.313 1.418z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M908.706 345.174l.768 3.793h-3.186v-3.793z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903.87 345.174l-.768 3.793h3.186v-3.793z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M906.288 325.692l-15.226 20.805 9.956-2.545 5.27 2.257z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M906.288 318.941l-12.831 17.532 8.39-2.145 4.441 1.902z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M906.288 314.346l-9.569 13.075 6.257-1.599 3.312 1.418z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M906.288 325.697l15.227 20.805-9.956-2.545-5.271 2.257z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M906.288 318.945l12.832 17.532-8.39-2.144-4.442 1.901z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M906.288 314.35l9.57 13.076-6.257-1.6-3.313 1.419z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M666.36 319.767l.768 3.793h-3.186v-3.793z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.524 319.767l-.768 3.793h3.186v-3.793z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M663.942 300.285l-15.227 20.805 9.956-2.545 5.271 2.257z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M663.942 293.533l-12.831 17.533 8.389-2.145 4.442 1.902z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M663.942 288.938l-9.57 13.076 6.257-1.599 3.313 1.418z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M663.942 300.29l15.227 20.805-9.956-2.545-5.271 2.256z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M663.942 293.538l12.831 17.532-8.389-2.144-4.442 1.901z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M663.942 288.943l9.57 13.076-6.257-1.6-3.313 1.418z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M696.653 310.972l.768 3.793h-3.186v-3.793z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.817 310.972l-.768 3.793h3.186v-3.793z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M694.235 291.49l-15.227 20.805 9.956-2.545 5.271 2.257z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M694.235 284.739l-12.831 17.532 8.39-2.145 4.441 1.902z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M694.235 280.143l-9.569 13.076 6.257-1.599 3.312 1.418z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M694.235 291.495l15.227 20.805-9.956-2.545-5.271 2.257z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M694.235 284.743l12.832 17.532-8.39-2.144-4.442 1.901z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M694.235 280.148l9.57 13.076-6.257-1.6-3.313 1.419z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveMountainPanorama);
export default __webpack_public_path__ + "static/media/waveMountainPanorama.54a534881109a1df4181f42271af44fb.svg";
export { ForwardRef as ReactComponent };